import styled from 'styled-components';

export const Title = styled.h2`
  text-align: center;
`;

export const Wrapper = styled.div`
  padding-top: 20px;
`;
